// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label.custom-setting--generic-checkbox.form-element{display:flex;flex-wrap:nowrap}label.custom-setting--generic-checkbox.form-element>.label-text{display:flex;padding-left:8px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
